export const LANGUAGE = 'hjbc.Language'
